import React, { useContext } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Retouching from '../../Retouching';
import routes from '../../../routes';
import useLocalStorage from "../../../hooks/useLocalStorage";
import useOptionsForPackage from "../../../hooks/useOptionsForPackage";
import useOrderPackage from "../../../hooks/useOrderPackage";
import { CustomerContext } from "../../../contexts/CustomerContext";
import Spinner from "../../Spinner";
import usePastImagesNoPlaceholder from "../../../hooks/usePastImagesNoPlaceholder";

export default function RetouchingPage() {
  const { orderPackageId } = useParams();
  const { customer } = useContext(CustomerContext);
  const { currentSchool, currentStudent } = customer
  const { isLoading: isLoadingPastImages, data: pastImages } = usePastImagesNoPlaceholder({ studentId: currentStudent.id });

  const [currentPromotionalCode] = useLocalStorage(`currentPromotionalCode-${currentStudent.id}`)

  const { data: orderPackage, isLoading } = useOrderPackage(orderPackageId);

  const { data: options, isLoading: isOptionsLoading } = useOptionsForPackage(orderPackage?.packageId, currentSchool.id)

  const history = useHistory();


  const currentPromotion = () => {
    if (!options.length) return;

    return options.find(option => option.code === (currentPromotionalCode || 1))
  }

  const handleContinue = () => {
    if (!orderPackage.package?.skipPastImages && pastImages.length > 0) {
      history.push('/past_images?toReview=true')
    } else {
      history.push(routes.review());
    }
  }

  if (isLoading || isOptionsLoading || isLoadingPastImages) return <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%)' }}><Spinner color='blue' /></div>;

  return (
    <Retouching
      student={currentStudent}
      orderPackageId={orderPackageId}
      onAccept={handleContinue}
      onDecline={handleContinue}
    />
  );
}
